import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChooseSignupExperimentVariants } from '../../model';
import type { RootState } from '../store';

export type FeatureFlagState = {
  readonly enableTintinMvp: boolean;
  readonly provisionSecondPartyApps: boolean;
  readonly enableDeferredSiteName: boolean;
  readonly enableDeferredFullName: boolean;
  readonly enableBundlesAfterSignup?: boolean;
  readonly enableDefaultExpandedEmail?: boolean;
  readonly enableUseCodeAWSContent?: boolean;
  readonly enableChooseSignup?: ChooseSignupExperimentVariants;
  readonly enableMoreSocialSignUpButtons?: boolean;
};

const initialState = {
  enableTintinMvp: false,
  provisionSecondPartyApps: false,
  enableDeferredSiteName: false,
  enableDeferredFullName: false,
  enableBundlesAfterSignup: false,
  enableDefaultExpandedEmail: false,
  enableUseCodeAWSContent: false,
  enableChooseSignup: ChooseSignupExperimentVariants.VARIANT2, // productionizing this variant
  enableMoreSocialSignUpButtons: false
} as FeatureFlagState;

const sliceFeatureFlags = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    updateFeatureFlags(state, action: PayloadAction<Record<string, unknown>>) {
      return { ...state, ...action.payload };
    }
  }
});

// export actions
export const { updateFeatureFlags } = sliceFeatureFlags.actions;
// optional - convenience function / state selector for minimal consumer syntax
export const selectFeatureFlags = (state: RootState) => state.featureFlags;
// export named reducer (for nicer syntax in store)
export const { reducer: reducerFeatureFlags } = sliceFeatureFlags;
